import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { MyProfileRoutingModule } from './my-profile-routing.module';
import { MyProfileComponent } from './my-profile.component';
import { SharedModule } from '../shared/shared.module';
import { FlexLayoutModule } from '@angular/flex-layout';
import { MyProfileFormComponent } from './my-profile-form/my-profile-form.component';
import { ReactiveFormsModule } from '@angular/forms';


@NgModule({
  declarations: [
    MyProfileComponent,
    MyProfileFormComponent
  ],
  imports: [
    CommonModule,
    MyProfileRoutingModule,
    SharedModule,
    FlexLayoutModule,
    ReactiveFormsModule
  ],
  exports: [
    MyProfileFormComponent
  ]
})
export class MyProfileModule { }
